export const applyOutgoingDeclineToTracker = (tracker, decline, options) => {
    const trackedDecline = tracker.get(decline.roomId);
    const declineState = trackedDecline && trackedDecline.notificationEventId === decline.notificationEventId
        ? trackedDecline
        : {
            notificationEventId: decline.notificationEventId,
            declinerIds: new Set(),
        };
    declineState.declinerIds.add(decline.senderId);
    tracker.set(decline.roomId, declineState);
    const targetCount = options.remoteJoinedIds.size;
    const declinedCount = declineState.declinerIds.size;
    if (targetCount === 0 && !options.isDirectRoom) {
        return { kind: 'ignore_partial', declinedCount, targetCount };
    }
    const allRemoteDeclined = targetCount > 0 &&
        [...options.remoteJoinedIds].every((userId) => declineState.declinerIds.has(userId));
    const treatAsOneToOne = options.isDirectRoom || targetCount <= 1;
    if (!treatAsOneToOne && targetCount > 0 && !allRemoteDeclined) {
        return { kind: 'ignore_partial', declinedCount, targetCount };
    }
    return { kind: 'end_call', declinedCount, targetCount };
};
//# sourceMappingURL=outgoingDeclineHandler.js.map